import { render, staticRenderFns } from "./reportForRepairCreate.vue?vue&type=template&id=60136e0c&scoped=true&"
import script from "./reportForRepairCreate.vue?vue&type=script&lang=js&"
export * from "./reportForRepairCreate.vue?vue&type=script&lang=js&"
import style0 from "./reportForRepairCreate.vue?vue&type=style&index=0&id=60136e0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60136e0c",
  null
  
)

export default component.exports